import AccountPage from './Account';
import './Account.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Actions
import {
  setLoading
} from '../../redux/loading/actions';
import {
  getCardBalance,
  setGoalAmount,
  requestCoupon
} from '../../redux/loyalty/actions';

const mapStateToProps = (state) => {
  return {
    cardNumber:     state.loyalty.cardNumber,
    cardAmount:     state.loyalty.cardAmount,
    bufferAmount:   state.loyalty.bufferAmount,
    goalAmount:     state.loyalty.goalAmount,
    lifetimeAmount: state.loyalty.lifetimeAmount,
    couponExpirationDate: state.loyalty.couponExpirationDate
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Loading
    setLoading,
    // Loyalty
    getCardBalance,
    setGoalAmount,
    requestCoupon,
  }, dispatch);
}

const ConnectedAccountPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AccountPage));

export default ConnectedAccountPage;



// WEBPACK FOOTER //
// ./src/pages/Account/index.js